// extracted by mini-css-extract-plugin
export var emphasizeQuantity = "_em-3";
export var flatBottomCorners = "_em-5";
export var productImage = "_em-0";
export var quantityContainer = "_em-2";
export var quantityHeader = "_em-6";
export var tooltip = "_em-1";
export var wrapAndEllipsesOverflow = "_em-4";